import { WOW } from 'wowjs';
export default {
  init() {
    const wow = new WOW();

    wow.init();
    $('#reachout').click(function () {
      $('#reachout_forms').toggle('slow');
      return false;
    });
    $('#close_btn').click(function () {
      $('#reachout_forms').toggle('slow');
      return false;
    });
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 10) {
        $('.sticky-site-header').addClass('shadow_css');
      } else {
        $('.sticky-site-header').removeClass('shadow_css');
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('#navbar-primary .navbar-nav li.dropdown .nav-link').click(function (e) {
      if ($(window).width() < 1200) {
        var grandparent = $(this).next();
        if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
          document.location.href = this.href;
        } else {
          $(this).addClass('open1');
          $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
          $(this).next('.dropdown-toggle1').click();
        }
      } else {
        location.href = this.href;
      }
      e.preventDefault();
    });

    $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
      var current = $(this).next();
      var current1 = $(this);
      var grandparent = $(this).parent().parent();
      grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
      grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
      $(this).toggleClass('opened');
      current.toggleClass('show1');
      e.stopPropagation();
    });
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js